import MySurveysTable, { ThElementsType } from "components/MySurveys/MySurveysTable";
import { useEffect, useState } from "react";
import { usePanelistCompleteStatusData } from "hooks/usePanelistCompleteStatusData-hook";
import { useTranslation } from "react-i18next";
import Pagination from "../../components/Pagination/Pagination";
import { rejectDataHandler } from "./dataHandler";
import { Badge, Card } from "components/ui";

const ThColumns: ThElementsType = {
  scope: "col",
  classes: "",
  dataKeys: [
    { id: 2, column: "Points", label: "points" },
    { id: 3, column: "Survey Name", label: "studyName" },
    { id: 4, column: "Date", label: "createdAt" },
    { id: 7, column: "Status", label: "status" },
  ],
};

export const ClaimedStudiesRejected = ({ setLoading }: any) => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [recordsPerPage] = useState(10);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const data = usePanelistCompleteStatusData({
    page: currentPage,
    fromDate: "2023-12-01+14:58:53",
    type: "reject",
  });

  const statusDisplay = () => {
    return (
      <Badge tone="danger" dot>
        {t("page.referral.Rejected")}
      </Badge>
    );
  };

  const dataSet = rejectDataHandler({
    data,
    indexOfFirstRecord,
    indexOfLastRecord,
    status: statusDisplay(),
  });

  useEffect(() => {
    if (data?.isLoading || data?.isFetching) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [data?.isLoading, data?.isFetching, data?.data]);
  return (
    <Card title="Rejected studies" subtitle="Study claims that did not pass review." flush>
      <MySurveysTable
        thElements={ThColumns}
        tdElements={dataSet}
        searchQuery="searchQuery"
        tdDataStyle=""
        tdRowStyle=""
        tableStyle=""
        startIndex={(currentPage - 1) * 10}
      />
      <div className="zs-table-footer justify-center sm:justify-end">
        <Pagination totalPages={data?.data?.totalPages} setCurrentPage={setCurrentPage} currentPage={currentPage} />
      </div>
    </Card>
  );
};
